import React, { useId } from "react";

import { formatPercent } from "../../../../../utils";
import {
  accountShareText,
  instrumentMarkColorOf,
} from "../Holdings/holdingDisplay";
import { ConcentrationListProps } from "./types";
import {
  ConcentrationFill,
  ConcentrationRow,
  ConcentrationRows,
  ConcentrationSection,
  ConcentrationTrack,
} from "./styles";

export const ConcentrationList: React.FC<ConcentrationListProps> = ({
  title,
  holdings,
}) => {
  const titleId = useId();
  return (
    <ConcentrationSection>
      <strong id={titleId}>{title}</strong>
      <ConcentrationRows aria-labelledby={titleId}>
        {holdings.map((holding) => {
          const { symbol } = holding.instrument;
          const shareLabel = `${symbol} ${accountShareText(holding.allocationPercent)}`;
          const shareText = formatPercent(holding.allocationPercent);
          return (
            <ConcentrationRow key={holding.id} aria-label={shareLabel}>
              <span title={symbol}>{symbol}</span>
              <ConcentrationTrack aria-hidden="true">
                <ConcentrationFill
                  data-testid="concentration-fill"
                  $share={holding.allocationPercent ?? 0}
                  $color={instrumentMarkColorOf(holding.instrument)}
                />
              </ConcentrationTrack>
              <span>{shareText}</span>
            </ConcentrationRow>
          );
        })}
      </ConcentrationRows>
    </ConcentrationSection>
  );
};
